import { render, staticRenderFns } from "./SystemConfigKeFu.vue?vue&type=template&id=57780671&"
import script from "./SystemConfigKeFu.vue?vue&type=script&lang=js&"
export * from "./SystemConfigKeFu.vue?vue&type=script&lang=js&"
import style0 from "./SystemConfigKeFu.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports